import React, { FC, ReactElement, useState } from 'react';
import DemoZoneVideoItem from './DemoZoneVideoItem';
import { ZoneDataProps, VideoProps } from '../DemoZone';
import ModalVideo from 'react-modal-video';
// import VideoModal from '../../../Modals/VideoModal/VideoModal'
import './demozone-videos.sass';
import { useSelector } from 'react-redux';
import localeFieldResolver from '../../../../helpers/locale-field-finder';
import { internalizationState } from '../../../../stores/reducers/sections';
interface Props {
  zoneData: ZoneDataProps
}

const DemoZoneVideos: FC<Props> = ({ zoneData }): ReactElement => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const [ videoId, setVideoId ] = useState<string>('');
  const { videoArchive: videos } = zoneData;
  const { activeLangState } = useSelector(internalizationState);
  const localizeData = {
    pageTitle_ru: 'Экскурсия',
    pageTitle_en: 'Excursion',
  };

  const localizedName = (field: string): string => localeFieldResolver(localizeData, field, activeLangState);

  // const [ isVideoOpen, setIsVideoOpen ] = useState<boolean>(false)

  // const closeVideo = (): void => {
  //   setVideoId('')
  //   setIsVideoOpen(false)
  // }
  
  const playVideo = (videoId: string, isVideoStart: boolean): void => {
    setVideoId(videoId);
    setIsVideoOpen(isVideoStart);
  };

  return (
    <>
      {/* <VideoModal
        videoId={videoId}
        isOpen={isVideoOpen}
        closeModal={() => closeVideo()}
      /> */}
      <ModalVideo
        channel="youtube"
        isOpen={isVideoOpen}
        videoId={videoId}
        onClose={() => setIsVideoOpen(false)}
      />
      <section className="inner-section">
        <div className="container">
          <div className="inner-section__head">
            <div className="section-title">{ localizedName('pageTitle_ru') }</div>
          </div>
          <div className="demozone-videos">
            {
              videos.map((video: VideoProps, index: number): ReactElement => (<DemoZoneVideoItem video={video} playVideo={playVideo} key={index} />))
            }
          </div>
        </div>
      </section>
    </>
  )
}

export default DemoZoneVideos
